module.exports = __webpack_public_path__ + "media/images/consumer/signup/plans/meal_preference/quick_easy--xxl@1x-9cb7413e662ec8aeae4f7f4d0a77f5c4.png";